import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/** 선택된 채팅방. 예약시트는 읽지 않고, 일렉트론과 상태를 맞추기 위해만 둔다 */
export type ChatRoomState = {
    selected: Record<string, unknown>
}

const state: ChatRoomState = {
    selected: {},
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetSelectedChatRoom': (store: Store, chatRoom: Record<string, unknown>): void => {
        store.commit('MU_SetSelectedChatRoom', chatRoom)
    },
}

const mutations = {
    'MU_SetSelectedChatRoom': (state: ChatRoomState, chatRoom: Record<string, unknown>): void => {
        state.selected = chatRoom
    },
}

const chatroom: Module<ChatRoomState, StoreState> = { state, actions, mutations }

export default chatroom
